import { Done, Pause, PlayArrow, PlayCircle } from '@mui/icons-material'
import { Box, Button, ButtonGroup, Divider, IconButton, Typography } from '@mui/material'
import { debounce, toNumber } from 'lodash'
import React, { useEffect, useState } from 'react'
import { Range } from '../../styled/Range'
import FinishFlag from '../../assets/icons/flag.svg'
import { Icon } from '@iconify/react'
import { useAuth } from "../../hooks/useAuth";
import { t } from 'i18next'

type MapControlBarProps = {
    play: boolean,
    changePlay: (play: boolean) => void,
    currentTime: string,
    bg: string,
    totalTime: string,
    max: number,
    currentIndex: number,
    onRangeChange: (val: number) => void,
    flIndex?: number | null,
    isFinishLineActive: boolean,
    mapMode?: 'gait' | 'speed'
    onMapModeChange?: (mode: 'gait' | 'speed') => void
}

function MapControlBar({
    play,
    changePlay,
    currentTime,
    totalTime,
    max,
    currentIndex,
    onRangeChange,
    bg,
    flIndex,
    isFinishLineActive,
    mapMode,
    onMapModeChange
}: MapControlBarProps) {


    const { isUserTypePolo } = useAuth()

    const getLeftPos = (): string => {
        if (flIndex) {
            return `${(flIndex / max) * 100}%`
        } else {
            return '0px'
        }

    }


    const speedUp = (value: number): number => {

        return Math.abs(value + currentIndex > max ? max : value + currentIndex)

    }

    const speedDown = (value: number): number => {

        return Math.abs(currentIndex - value < 0 ? 0 : currentIndex - value)

    }

    return (
        <>
            <Box display={'flex'} flexDirection={'column'} mt={2}>

                <Box>
                    <Range name='track' bg={bg} id='track' step={1}
                        onChange={e => onRangeChange(toNumber(e.target.value))} min={0} max={max}
                        value={currentIndex} type='range'></Range>

                    {
                        (flIndex && isFinishLineActive) && <Box position={'relative'}>
                            <div className='finish_section' style={{
                                position: 'absolute',
                                left: getLeftPos(),
                                zIndex: 99,
                                bottom: 5,
                                transform: 'translateX(-30%)',
                                width: 10,
                                height: 24
                            }}></div>
                            {/* <img src={FinishFlag} alt='finish-flag' ></img> */}
                        </Box>
                    }


                </Box>


                <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} gap={2}>
                    <Box display={'flex'} alignItems={'center'} gap={2}>

                        <Box display={'flex'} alignItems={'center'} gap={0}>
                            {
                                isUserTypePolo && <IconButton size='small' onClick={() => onRangeChange(speedDown(10))}>{<Icon
                                    icon='ri:replay-10-line' />}</IconButton>
                            }

                            <IconButton size='small' onClick={() => onRangeChange(speedDown(30))}>{<Icon
                                icon='ri:replay-30-line' />}</IconButton>
                            <IconButton size='small' onClick={() => changePlay(!play)}>{!play ?
                                <Icon icon='weui:play-filled' /> :
                                <Icon icon='material-symbols-light:pause-rounded' />}</IconButton>
                            <IconButton size='small' onClick={() => onRangeChange(speedUp(30))}>{<Icon
                                icon='ri:forward-30-fill' />}</IconButton>
                            {
                                isUserTypePolo && <IconButton size='small' onClick={() => onRangeChange(speedUp(10))}>{<Icon
                                    icon='ri:forward-10-fill' />}</IconButton>
                            }


                        </Box>

                        <Typography variant='caption' color='inherit' fontSize={12}>{currentTime} / {totalTime}</Typography>
                    </Box>
                    {
                        isUserTypePolo && typeof onMapModeChange === 'function' && <>
                            <ButtonGroup variant="text" aria-label="Basic button group">
                                <Button onClick={() => typeof onMapModeChange === 'function' && onMapModeChange('gait')} variant={mapMode === 'gait' ? 'contained' : 'text'} size='small' sx={{ fontWeight: 400, fontSize: 12 }}>{t('map:allure')}</Button>
                                <Button onClick={() => typeof onMapModeChange === 'function' && onMapModeChange('speed')} variant={mapMode === 'speed' ? 'contained' : 'text'} size='small' sx={{ fontWeight: 400, fontSize: 12 }}>{t('map:speed')}</Button>
                            </ButtonGroup>
                        </>
                    }

                </Box>
            </Box>
        </>

    )
}

export default MapControlBar